import $clamp from 'clamp-js'

export default {
  bind(elem, binding) {
    $clamp(elem, { clamp: binding.value })
    elem.style.textOverflow = ''
  },
}
